import React, { useState } from "react";

interface CollapsibleSectionProps {
  title: string;
  defaultOpen?: boolean;
  count?: number;
  /** Optional controls rendered on the right of the header (clicks won't toggle the section) */
  headerActions?: React.ReactNode;
  children: React.ReactNode;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  defaultOpen = true,
  count,
  headerActions,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="ev-section">
      <div className="ev-section-header" onClick={() => setOpen(!open)}>
        <span>
          {title}
          {count != null && count > 0 && (
            <span style={{ fontWeight: 400, fontSize: 11, color: "var(--text-muted)", marginLeft: 6 }}>
              ({count})
            </span>
          )}
        </span>
        <span className="ev-section-header-right">
          {headerActions && (
            <span
              className="ev-section-header-actions"
              onClick={(e) => e.stopPropagation()}
            >
              {headerActions}
            </span>
          )}
          <i className={`fa fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 11 }} />
        </span>
      </div>
      {open && <div className="ev-section-body">{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
